/* Copyright (c) 2021-2023 Nordcloud Oy or its affiliates. All Rights Reserved. */

import { ReactNode } from "react";
import CopyToClipboard from "react-copy-to-clipboard";
import { Box, FlexContainer, SVGIcon, theme } from "@nordcloud/gnui";
import { showSimpleInfo } from "~/services/toast";

type Props = {
  children: ReactNode;
  value: string;
};

export function CopyBox({ children, value }: Props) {
  return (
    <Box
      boxStyle="grey"
      marginBottom={theme.spacing.spacing01}
      padding={theme.spacing.spacing02}
    >
      <FlexContainer justifyContent="space-between">
        <div>{children}</div>
        <CopyToClipboard
          text={value}
          css={{
            cursor: "pointer",
          }}
          onCopy={() => showSimpleInfo("Command copied to clipboard")}
        >
          <SVGIcon name="copy" />
        </CopyToClipboard>
      </FlexContainer>
    </Box>
  );
}
